import { jsx as _jsx } from "react/jsx-runtime";
import { AskInputPlusMenuSpaces } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputPlusMenuSpaces.js';
import { trackPlusMenuOpenChange } from '#pplx/frontend/apps/ask/events/ask-input-plus-menu/analytics.js';
import { createProjectSelectorPluginFactory } from '#pplx/frontend/composer-sdk-plugins/project-selector/index.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useMemo } from 'react';
const projectSelectorPluginFactory = createProjectSelectorPluginFactory();
/** @returns The shared project picker, or undefined when the caller hides leading controls. */
export function useAskComposerProjectSelectorPlugin({ composerRef, enabled, }) {
    const { track } = useInstrumentation();
    const handleOpenChange = useCallback((open) => trackPlusMenuOpenChange({ open, track }), [track]);
    const insertMention = useCallback((mention) => composerRef.current?.insertMention(mention) ?? 'unavailable', [composerRef]);
    const renderProjectSelector = useCallback(({ closeMenu, insertProject }) => (_jsx(AskInputPlusMenuSpaces, { onSpaceSelect: (space) => {
            const result = insertProject({ ...space, mention: toProjectMention({ project: space }) });
            if (result !== 'unavailable')
                closeMenu();
        } })), []);
    return useMemo(() => enabled
        ? projectSelectorPluginFactory({
            insertMention,
            onOpenChange: handleOpenChange,
            renderProjectSelector,
        })
        : undefined, [enabled, handleOpenChange, insertMention, renderProjectSelector]);
}
function toProjectMention({ project, }) {
    const icon = project.icon?.type === 'source' ? undefined : project.icon;
    return {
        id: project.uuid,
        kind: 'space',
        text: project.label,
        ...(icon === undefined ? {} : { icon }),
    };
}
//# sourceMappingURL=useAskComposerProjectSelectorPlugin.js.map